import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@pankod/refine-mui";
import React from "react";
import useAuth from "contexts/AuthContext";
import { useSelect } from "@pankod/refine-core";

function SelettoreStruttura({ idStruttura, setIdStruttura }) {
  const auth = useAuth();
  const owner = auth.user?.id ? auth.user?.id : "";

  const { options: mieStrutture } = useSelect({
    resource: "strutture",
    pagination: {
      pageSize: 999,
    },
    optionLabel: "businessName", // -> mieStrutture.label
    optionValue: "id", // -> mieStrutture.value
    metaData: {
      fields: ["id", "businessName"],
    },
    filters: [
      {
        field: "owner.id",
        operator: "eq",
        value: owner,
      },
      { field: "gestore", operator: "eq", value: "false" },
    ],
    queryOptions: {
      enable: auth.user?.id, // qui una condizione che va a true quando ho ottenuto l'id
    },
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={3} sx={{ height: "100%" }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Statistiche struttura:
        </Typography>
      </Grid>
      <Grid item xs={6} sx={{ height: "100%" }}>
        <FormControl fullWidth>
          <InputLabel id="struttura-label">Struttura</InputLabel>
          <Select
            id="struttura"
            value={idStruttura}
            label="Struttura"
            onChange={(e) => setIdStruttura(e.target.value)}
            fullWidth={true}
          >
            <MenuItem value={0}> </MenuItem>
            {mieStrutture?.map((s) => (
              <MenuItem key={s.value} value={s.value}>
                {s.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default SelettoreStruttura;
